<template>
	<editor
		:show.sync="editorVisible"
		:data-model-name="editorDataModel"
		:fields="editorFields"
		:use-submit-event="true"
		@submit="onSubmit"
		:check-ever-edited="false"
		v-if="editorVisible"
		:max-info="{k:'total_price',v:totalPay}"
		:default-value="{total_price:totalPay}"
	>
		<template slot="info">
			<div class="col-6">
				<el-form-item label="待支付">{{totalPay}}</el-form-item>
			</div>
		</template>
	</editor>
</template>

<script>
export default {
	data() {
		return {
			editorDataModel: "Cashflow",
			
		};
	},
	computed: {
		editorVisible: {
			get: function() {
				return this.show;
			},
			set: function(val) {
				this.$emit("update:show", val);
			}
		},
		editorFields:  {
			get: function() {
				const payEnums = {
					'10':1,
					'11':1,
					'20':1,
					'21':1,
					'30':1,
					'40':1,
					'50':1
				};

				const showEnums = [];

				if (this.usedPayMethods) {
					this.usedPayMethods.forEach(method => {
						payEnums[method] = 0;
					})
				}
				for (let k in payEnums) {
					if (payEnums[k]) {
						showEnums.push(k);
					}
				}
				const fields = [
					{
						name: "pay_method",
						col: 6,
						params:{
							showEnums:showEnums
						}
					},
					{
						name: "total_price",
						col: 6
					},
					{
						name: "desc",
						col: 6
					},
					{
						name: "primary_img",
						col: 6
					}
				];
				return fields
			},
			
		},
		
	},
	props: {
		show: {
			type: Boolean,
			default: false
		},
		usedPayMethods: {
			type: Array,
			default: function() {
				return []
			}
		},
		totalPay: {
			type: Number,
			default: 0
		},
	},
	methods: {
		onSubmit(val) {
			this.$emit("submit", val);
			this.editorVisible = false;
		}
	}
};
</script>